module.exports = __webpack_public_path__ + "static/media/view1.baccf0e2.jpg";